export const commonLocales = {
  actions: "Actions",
  addNew: "Add New",
  addNewNote: "Add New Note",
  admin: "Admin",
  alerts: "Alerts",
  all: "All",
  approve: "Approve",
  approveProfessional: "Approve Professional",
  applicantStatus: {
    applied: "Applied",
    assigned: "Assigned",
    cancelled: "Cancelled",
    completed: "Completed",
    fulfilled: "Fulfilled",
  },
  archived: "Archived",
  assign: "Assign",
  back: "Back",
  backToDentalOffices: "Back to Dental Offices",
  cancel: "Cancel",
  cancellationByOffice: "Cancellation By Office",
  cancellationDetails: "Cancellation Details",
  cancellationPeriod: "Cancellation Period",
  categoryManagement: "Category Management",
  city: "City",
  confirm: "Confirm",
  confirmSubmit: "Confirm Submit Profile",
  confirmSubmitMessage: "Are you sure you want to submit this profile?",
  contract: "Agreements",
  contracts: "Contracts",
  disable: "Disable",
  dentalOffices: "Dental Offices",
  dentalProfessionals: "Dental Professionals",
  document: "Document",
  download: "Download",
  downloadInvoice: "Download Invoice",
  edit: "Edit",
  empty: "",
  enable: "Enable",
  eSign: "eSign",
  expiry: "Session expired. Please login to continue using",
  expenses: "Expenses",
  submitPayScale: "Submit Pay Scale",
  fileName: "File Name",
  forgotPasswordHeading: "Forgot Password",
  forgotPasswordWarning:
    "Please enter your username or email address. You will receive a link to create a new password via email.",
  home: "Home",
  job: {
    error: {
      jobTimeConflict: "Job time should be between the shift time",
      pleaseSelectCancelReason: "Please select a job cancel reason.",
      pleaseSelectDateToCancel: "Please select a date to cancel.",
      pleaseEnterOtherReason: "Please enter other reason.",
    },
    fields: {
      action: "Action",
      category: "Role",
      createdDate: "Created Date",
      daysToFill: "Days to Fill",
      jobDate: "Job Date",
      jobId: "Job ID",
      jobRole: "Job Role",
      jobType: "Job Type",
      location: "Location",
      miles: "Miles",
      office: "Office",
      officeName: "Office Name",
      placementType: "Placement Type",
      range: "Range",
      state: "State",
      status: "Status",
      type: "Service Type",
      position: "Position",
      startDate: "Start Date",
      endDate: "End Date",
      zip: "Zip Code",
      assignedBy: "Assigned By",
      assignedTo: "Assigned to",
      recruiter: "Recruiter",
      assignType: "Assign Type",
      professionalName: "Professional Name",
      autoPublishedJobs: "Auto-published",
      auto: "Auto",
    },
    filter: {
      name: "Name",
      search: "Search",
    },
    jobType: {
      contract: "Contract/Temp",
      singleDay: "Single Day",
      multiDay: "Multi Day",
      directHire: "Direct Hire",
    },
    jobStatus: {
      open: "Pending",
      published: "Open",
      hired: "Filled",
      completed: "Completed",
      cancelled: "Cancelled",
      rejected: "Rejected",
      unfilled: "Unfilled",
    },
    assignType: { assigned: "Assigned", unAssigned: "Unassigned" },
    label: {
      applicationDueDate: "Application Due date",
      comments: "Comments",
      description: "Description",
      publishOne: "You are about to publish the job.",
      publishTwo: "Please make sure the pay rate is accurate",
      publishDirectJob: " You are about to publish the job.",
      selectReason: "Select Reason",
      unassignApplicantReason: "Reason for unassigning",
    },
    menu: {
      title: {
        cancel: "Cancel Job",
        publish: "Publish Job",
        reject: "Reject Job",
        unassign: "Unassign Professional",
      },
      cancel: "Cancel Job",
      duplicate: "Duplicate Job",
      edit: "Edit",
      publish: "Publish ",
      ConfirmButton: "Yes",
      cancelButton: "No",
      OkButton: "Ok",
      reject: "Reject",
      view: "View",
      assignJob: "Assign Job",
      unassignJob: "Unassign Job",
      editPayrate: "Edit Payrate",
    },
    message: {
      cancel: "Job Cancelled successfully",
      publish: "Job published successfully",
      Reject: "Job Rejected successfully",
    },
    noApplicationsYet: "No applications received yet.",
    noDocumentUploadYet: "No document uploaded yet.",
    noJobsPostedYet: "No Jobs posted yet.",
    noProfessionalsYet: "No professionals to list.",
    noRevenueYet: "No revenues posted yet",
    timesheetStatus: {
      approved: "Approved",
      cancelled: "Cancelled",
      disputed: "In Dispute",
      pending: "Pending",
      rejected: "Rejected",
      submitted: "Submitted",
    },
  },
  invalidDate: "Invalid Date",
  invalidTime: "Invalid Time",
  jobs: "Jobs",
  landmark: "Office Landmark /Notes",
  loading: "Loading...",
  loginHeading: "Login",
  loginSubHeading: "Sign In to your account",
  maskText: "XXXXXXXXXXXXXXXXXXX",
  no: "No",
  noLogsFound: "No logs found",
  noProfessionFound:
    "No professionals have been assigned to the selected date.",
  noResultsFound: "No results found",
  notAvailableSeparator: "-",
  na: "NA",
  notes: "Notes",
  notifications: "Notifications",
  noTimesheetYet: "No Timesheet item found.",
  of: "of",
  officeAddressLineOne: "Office Address Line 1",
  officeAddressLineTwo: "Office Address Line 2",
  officeName: "Office Name",
  officeTelephoneNumber: "Office Telephone Number",
  officeMobileNumber: "Office Mobile Number",
  contactPerson: "Contact Name",
  ok: "Ok",
  otherDocuments: "Others",
  page: "Page",
  pageSize: "Page Size",
  payRangeAndBillRates: "Pay Range and Bill Rates",
  payScaleName: "Pay Scale Name",
  pleaseEnterAComment: "Please enter a comment",
  pleaseSelectAReason: "Please select a reason",
  pleaseSelect: "Please Select",
  pm: "pm",
  postedJobs: "Posted Jobs",
  proceed: "Proceed",
  professionalLabel: "The following documents will be released to professional",
  resetPasswordHeading: "Reset Password",
  reject: "Reject",
  rejectProfessional: "Reject Professional",
  release: "Release Documents",
  releaseContractHeadingSelect: "Select MSA",
  releasedOn: "Released On",
  releasedBy: "Released By",
  releaseText:
    "You are about to release the selected contracts to the user. A copy of each document will be shared in the email alert as well.  Click ok to proceed",
  remove: "Delete",
  reset: "Reset",
  revenue: {
    billRateRevenue: "Total Revenue($)",
    email: "Email",
    name: "Name of User",
    role: "Role Assigned",
    id: "ID",
    creditAmount: "Credit Amount",
  },
  revenueUser: {
    amount: "Amount",
    city: "City",
    date: "Date",
    id: "ID",
    name: "Name",
    officeName: "Office Name",
    revenueReport: "Revenue Report",
    revenueReportByUser: "Assignments Invoices of Admin User",
    role: "Role",
    state: "State",
    employeeName: "Employee Name",
  },
  search: "Search",
  selectOffice: "Select Office: ",
  settings: "Settings",
  state: "State/Region",
  submit: "Submit",
  submitProfile: "Submit Profile",
  titleReleaseContract: "Release Documents",
  officeTitleReleaseContract: "Release Contracts",
  timesheet: {
    list_fields: {
      actions: "Actions",
      id: "ID",
      pro_name: "Name of Professional",
      start_date: "Start Date",
      end_date: "End Date",
      total_bill_hours: "Total billable hours",
      total_bill_rate: "Total Bill Rate",
      total_pay_rate: "Total Pay Rate",
      type: "Service Type",
      view: "View",
      billAmount: "Bill Amount",
    },
    pro_entry_fields: {
      actions: "Actions",
      date: "Date",
      job_id: "Job Id",
      job_role: "Job Role",
      job_type: "Service Type",
      office_name: "Office Name",
      paymentRequired: "Payment Required",
      billable_hours: "Billable Hours",
      status: "Status",
      view: "View",
      submittedDate: "Submitted Date",
    },
    timesheetStatus: {
      pending: "Pending",
      submitted: "Submitted",
      approved: "Approved",
      cancelled: "Cancelled",
      rejected: "Rejected",
      dispute_raised: "In Dispute",
    },
  },
  to: "to",
  today: "Today",
  unAssign: "Unassign",
  update: "Update",
  upload: {
    done: "File Uploaded Successfully!",
    error: "Error uploading file",
    image: "Image Uploaded Successfully!",
    inProgress: "Your file is being uploaded",
  },
  uploadedBy: "Uploaded By",
  uploadedOn: "Uploaded On",
  usersWithoutEditPermissionWarning:
    "You do not have sufficient permissions to view/edit some profiles ",
  viewAction: "View",
  viewAll: "View all",
  viewFieldNotAvailable: "NA",
  viewNote: "View Notes",
  viewPageApproveButton: "Approve",
  viewPageCancelButton: "Cancel",
  viewPageRejectButton: "Reject",
  viewPageReleaseContractButton: "Release Documents",
  viewPdf: "View PDF",
  viewPdfInNewWidow: "View PDF in New Window",
  yes: "Yes",
  zip: "Zip",
  noRecordsFound: "No Records Found",
  manualInvoice: {
    invoiceId: "Invoice ID",
    professionalName: "Professional Name",
    jobRole: "Job Role",
    officeName: "Office Name",
    dateRange: "Date Range",
    hours: "Hours",
    billRate: "Bill Rate",
    description: "Description",
    totalAmount: "Total Amount ($)",
    manualInvoiceOfAdminUser: "Manual Invoices of Admin User",
  },
  primaryEmail: "Primary Email",
  secondaryEmail: "Secondary Email",
  generalOfficeEmail: "General Office Email",
  website: "Website",
  pcStatus: "PC Status Update",
  pcStatusSuccessMsg: "PC Status updated successfully",
  updateStatus2: "Recruiter status update",
  updateStatus2SuccessMsg: "Recruiter status updated successfully",
  recaptchaValidationError: "Please verify that you are not a robot.",
  editPayScaleDesc: "You are about to edit the payscale of the job",
  publishWithPayRange: "Publish with payrange",
  assignWarmMsgWithoutPayrate:
    " You are assigning professionals to an auto-published job without a pay range. Please verify that the pay details are configured appropriately.",
  csvExporter: {
    title: "Export Records",
    subtitle: "Download filtered records as a spreadsheet",
    needHelp: "Need help ?",
    exportScope: "Export scope",
    exportFromList: "Export from list",
    exportAll: "Export all",
    exportListCountPreview: "Export from list: {count} records",
    exportAllCountPreview: "Export all: {count} records",
    selectedExportCountPreview: "{count} records will be exported",
    totalRecords: "Total Records",
    recordsLabel: "records",
    exportButton: "Export Excel",
    loading: "Exporting...",
    successMessage: "Excel file exported successfully.",
    noDataFound: "No records found to export.",
    errorGeneric: "An error occurred while exporting data.",
    tourOverviewTitle: "Export widget",
    tourOverviewDesc:
      "Use this widget to download records as an Excel file based on your current filters.",
    tourScopeTitle: "Choose export scope",
    tourScopeDesc:
      "Select Export from list to download the current table page, or Export all to download up to 10,000 filtered records.",
    tourExportTitle: "Download Excel",
    tourExportDesc:
      "Click Export Excel to generate and download the spreadsheet for your selected scope.",
  },
  excelImporter: {
    browseFiles: "Browse files",
    changeFile: "Change",
    chooseType: "Choose type",
    close: "Close",
    download: "Download",
    downloadFileStep: "Excel template",
    downloadHint: "Download the .xlsx template for the selected type.",
    downloadTemplate: "Download Template",
    downloadTemplateTitle: "Download Excel Template",
    downloading: "Downloading...",
    downloadFailed: "Failed to download the Excel template.",
    downloadFileFailed: "Failed to download the import file.",
    duplicateValues: "Duplicate values",
    headerMismatch:
      "The file headers do not match the {type} template. Download the template and try again.",
    importExcel: "Import Excel",
    importFailed: "Failed to import the Excel file.",
    importTitle: "Import Excel",
    invalidFileType: "Please upload an .xlsx file.",
    invalidValues: "Invalid values",
    missingValues: "Missing values",
    noDataRows: "The file has no data rows to import.",
    parseError: "Unable to read this Excel file.",
    readyToUpload: "{count} row(s) passed validation and are ready to upload.",
    refresh: "Refresh",
    rowLabel: "Row {row}",
    selectTypeFirst: "Select a type to show the upload area.",
    selectTypeToDownload: "Select a type to download its Excel template.",
    typeRequired: "Please select a type.",
    upload: "Upload",
    uploading: "Uploading...",
    uploadAreaLabel: "Drop an .xlsx file here or click to browse",
    uploadFileStep: "Excel file",
    uploadHint:
      "Use the template for the selected type. Headers must match exactly.",
    uploadSuccess:
      "{count} row(s) sent for import. Check the import log for status.",
    backendErrorsTitle: "Validation errors",
    completed: "Completed",
    errorsLabel: "Errors",
    errorRowLabel: "Row {row}",
    importInProgress: "Import in progress",
    importLog: "Import Log",
    importStarted: "Import initiated.",
    importedLabel: "Imported",
    initiateImport: "Initiate import",
    initiateImportConfirm:
      "Are you sure you want to initiate import for {file}?",
    initiatedBy: "Initiated by",
    loadingErrors: "Loading errors...",
    noErrorsFound: "No errors found",
    noImports: "No imports found",
    notInitiated: "Not initiated",
    rowCount: "{count} rows",
    rowsLabel: "Rows",
    uploadedBy: "Uploaded by",
    validated: "Validated",
    validationFailed: "Validation failed",
    validationInProgress: "Validation in progress",
    viewErrors: "View errors",
  },
  directHireWarnMsgWithoutPayrate:
    "You are assigning professionals to an auto-published job. Please verify the details.",
  autoPublishDirectHire: "You are about to publish an auto-published job.",
  noLonger: "No Longer with Company",
};
